<div class="h-100 container-fuild">
  <table class="table border-0" style="height: 0px; overflow-y: auto; overflow-x: auto;">
    <thead>
      <tr>
        <th>Environment Name</th>
        <th>Region</th>
        <th>Servers</th>
        <th>Server Plan</th>
        <th>Operating System</th>
      </tr>
    </thead>

    <tbody>
      <!-- Iterate over environments if there are any -->
      <tr *ngFor="let environment of selectedEnvironments">
        <td>{{ environment.name }} ({{ environment.type }})</td>
        <td>{{ environment.region }}</td>
        <td>
          <div *ngFor="let server of environment.servers.split(', ')" class="pb-1">
            <div class="d-flex flex-row align-items-center fa-parent">
              <div class="circle"></div>
              <span>{{ server }}</span>
            </div>
          </div>
        </td>
        <td class="pl-3">{{ environment.serverProfile }}</td>
        <td class="pl-2">{{ environment.os }}</td>
      </tr>

      <!-- if no environments are selected -->
      <tr *ngIf="selectedEnvironments.length === 0">
        <td colspan="6">
          <p>No Peer Environment Selected.</p>
        </td>
      </tr>

    </tbody>
  </table>
</div>
